import * as React from 'react';
import { AnimateHeight } from '../AnimateHeight/AnimateHeight';
import { noop } from '../helper';
import { useId } from '../helper/hooks';

export interface IAccordionPanelProps {
  title: string;
  onToggle?: () => void;
  expanded?: boolean;
  id?: string;
  children: React.ReactNode;
}

/**
 * AccordionPanel should be used as direct child of `Accordion`
 */
export const AccordionPanel = (props: IAccordionPanelProps) => {
  const id = useId(props.id);
  const onToggle = props.onToggle || noop;

  return (
    <div className="panel">
      <div className="panel-heading" role="tab" id={'panel-head' + id}>
        <h4 className="panel-title">
          <a
            onClick={(e) => {
              e.preventDefault();
              onToggle();
            }}
            aria-expanded={props.expanded}
            aria-controls={'panel' + id}
            role="button"
            className={props.expanded ? '' : 'collapsed'}
            href="#"
          >
            {props.title}
          </a>
        </h4>
      </div>
      <AnimateHeight
        id={'panel' + id}
        className="panel-collapse"
        role="tabpanel"
        aria-labelledby={'panel-head' + id}
        expanded={props.expanded ? true : false}
      >
        <div className="panel-body">{props.children}</div>
      </AnimateHeight>
    </div>
  );
};
